import {
  EAnalyticsAuthMethod,
  EAnalyticsEvent,
} from "@frontend-shared/product-analytics";
import type { ISignupData } from "@frontend-shared/types";
import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/api/services";
import { useProductAnalytics } from "@/hooks/use-product-analytics";

export const useSignup = () => {
  const { capture } = useProductAnalytics();

  return useMutation({
    mutationFn: (data: ISignupData) => authApi.signup(data),
    // NOTE: NSAI-4615 — the top of the activation funnel. Every downstream
    // conversion rate is measured against this event, so it fires on the
    // account being created rather than on the form being submitted.
    onSuccess: () => {
      capture({
        event: EAnalyticsEvent.AUTH_SIGNUP_COMPLETED,
        properties: { method: EAnalyticsAuthMethod.PASSWORD },
      });
    },
  });
};
